import { render } from "./pricing-list.vue?vue&type=template&id=e9c91136"
import script from "./pricing-list.vue?vue&type=script&lang=js"
export * from "./pricing-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__